module.exports = __webpack_public_path__ + "static/img/10.cbbe326.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/10.png
// module id = Jvpd
// module chunks = 0